var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',_vm._g({staticClass:"avatar",attrs:{"src":_vm.url}},_vm.on))
}
var staticRenderFns = []

export { render, staticRenderFns }